var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
      },
    },
    [
      _c("g", { attrs: { fill: _vm.color } }, [
        _c("path", {
          attrs: {
            d: "M11 2.2c-4.86 0-8.8 3.94-8.8 8.8s3.94 8.8 8.8 8.8 8.8-3.94 8.8-8.8-3.94-8.8-8.8-8.8zM11 17.6c-3.645 0-6.6-2.955-6.6-6.6s2.955-6.6 6.6-6.6c3.645 0 6.6 2.955 6.6 6.6s-2.955 6.6-6.6 6.6zM7.7 11c0-1.823 1.477-3.3 3.3-3.3s3.3 1.477 3.3 3.3c0 1.823-1.477 3.3-3.3 3.3s-3.3-1.477-3.3-3.3z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }